import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useConvexAuth } from "convex/react";
import { useEffect } from "react";

import { AuthLoadingScreen, SignInScreen } from "@/components/auth";

export const Route = createFileRoute("/login")({
  component: LoginRoute,
});

function LoginRoute() {
  const navigate = useNavigate();
  const { isLoading, isAuthenticated } = useConvexAuth();

  // If this route renders while already authenticated, move to the app root.
  useEffect(() => {
    if (!isLoading && isAuthenticated) {
      navigate({ to: "/", replace: true });
    }
  }, [isLoading, isAuthenticated, navigate]);

  if (isLoading) {
    return <AuthLoadingScreen />;
  }

  if (!isAuthenticated) {
    return <SignInScreen />;
  }

  return <AuthLoadingScreen />;
}
